import IBrightness from '../../../FrontApplet/Management/Screen/IBrightness';
import IOrientation from '../../../FrontApplet/Management/Screen/IOrientation';
import { EmptyObject } from '../../EmptyObject';

export type ManagementScreenRequests =
	| ManagementScreenResizeRequest
	| ManagementScreenGetOrientationRequest
	| ManagementScreenSetBrightnessRequest
	| ManagementScreenGetBrightnessRequest
	| ManagementScreenTakeScreenshotRequest
	| ManagementScreenPowerOnRequest
	| ManagementScreenPowerOffRequest
	| ManagementScreenIsPoweredOnRequest;

export const ManagementScreenResizeRequest = 'sos.Monitoring.Management.ManagementScreenResizeRequest';
export interface ManagementScreenResizeRequest {
	type: typeof ManagementScreenResizeRequest;
	baseUrl: string;
	orientation: string;
	resolution: string;
	currentVersion: string;
	videoOrientation?: string;
}

export const ManagementScreenResizeResult = 'sos.Monitoring.Management.ManagementScreenResizeResult';
export interface ManagementScreenResizeResult {
	type: typeof ManagementScreenResizeResult;
	result: EmptyObject;
}

export const ManagementScreenGetOrientationRequest = 'sos.Monitoring.Management.ManagementScreenGetOrientationRequest';
export interface ManagementScreenGetOrientationRequest {
	type: typeof ManagementScreenGetOrientationRequest;
}

export const ManagementScreenGetOrientationResult = 'sos.Monitoring.Management.ManagementScreenGetOrientationResult';
export interface ManagementScreenGetOrientationResult {
	type: typeof ManagementScreenGetOrientationResult;
	result: IOrientation;
}

export const ManagementScreenSetBrightnessRequest = 'sos.Monitoring.Management.ManagementScreenSetBrightnessRequest';
export interface ManagementScreenSetBrightnessRequest {
	type: typeof ManagementScreenSetBrightnessRequest;
	timeFrom1: string;
	brightness1: number;
	timeFrom2: string;
	brightness2: number;
}

export const ManagementScreenSetBrightnessResult = 'sos.Monitoring.Management.ManagementScreenSetBrightnessResult';
export interface ManagementScreenSetBrightnessResult {
	type: typeof ManagementScreenSetBrightnessResult;
	result: EmptyObject;
}

export const ManagementScreenGetBrightnessRequest = 'sos.Monitoring.Management.ManagementScreenGetBrightnessRequest';
export interface ManagementScreenGetBrightnessRequest {
	type: typeof ManagementScreenGetBrightnessRequest;
}

export const ManagementScreenGetBrightnessResult = 'sos.Monitoring.Management.ManagementScreenGetBrightnessResult';
export interface ManagementScreenGetBrightnessResult {
	type: typeof ManagementScreenGetBrightnessResult;
	result: IBrightness;
}

export const ManagementScreenTakeScreenshotRequest = 'sos.Monitoring.Management.ManagementScreenTakeScreenshotRequest';
export interface ManagementScreenTakeScreenshotRequest {
	type: typeof ManagementScreenTakeScreenshotRequest;
	uploadBaseUrl: string;
	computeHash?: boolean;
}

export const ManagementScreenTakeScreenshotResult = 'sos.Monitoring.Management.ManagementScreenTakeScreenshotResult';
export interface ManagementScreenTakeScreenshotResult {
	type: typeof ManagementScreenTakeScreenshotResult;
	screenshotUrl: string;
	aHash?: string;
}

export const ManagementScreenPowerOnRequest = 'sos.Monitoring.Management.ManagementScreenPowerOnRequest';
export interface ManagementScreenPowerOnRequest {
	type: typeof ManagementScreenPowerOnRequest;
}

export const ManagementScreenPowerOnResult = 'sos.Monitoring.Management.ManagementScreenPowerOnResult';
export interface ManagementScreenPowerOnResult {
	type: typeof ManagementScreenPowerOnResult;
	result: EmptyObject;
}

export const ManagementScreenPowerOffRequest = 'sos.Monitoring.Management.ManagementScreenPowerOffRequest';
export interface ManagementScreenPowerOffRequest {
	type: typeof ManagementScreenPowerOffRequest;
}

export const ManagementScreenPowerOffResult = 'sos.Monitoring.Management.ManagementScreenPowerOffResult';
export interface ManagementScreenPowerOffResult {
	type: typeof ManagementScreenPowerOffResult;
	result: EmptyObject;
}

export const ManagementScreenIsPoweredOnRequest = 'sos.Monitoring.Management.ManagementScreenIsPoweredOnRequest';
export interface ManagementScreenIsPoweredOnRequest {
	type: typeof ManagementScreenIsPoweredOnRequest;
}

export const ManagementScreenIsPoweredOnResult = 'sos.Monitoring.Management.ManagementScreenIsPoweredOnResult';
export interface ManagementScreenIsPoweredOnResult {
	type: typeof ManagementScreenIsPoweredOnResult;
	result: boolean;
}
